import { useState, useEffect, useRef, useCallback } from "react";
import * as storage from "../../browserStorage";

const AgeGate = ({
    locationGateConfig,
    renderHtml,
    handleAgeGate,
    storedRetailer,
    retailers,
    retailerId,
    ageGateType,
    nonHeadlessRetailerData,
}) => {
    const [currentRetailer, setCurrentRetailer] = useState(null);
    const [isOldEnough, setIsOldEnough] = useState(true);
    const [birthDate, setBirthDate] = useState({ month: "", day: "", year: "" });
    const [ageGateContent, setAgeGateContent] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const ageGateContentSet = useRef(false);
    const [formError, setFormError] = useState('');

    const handleYesClick = useCallback(() => {
        if (currentRetailer) {
            handleAgeGate(currentRetailer);
        } else if (nonHeadlessRetailerData) {
            handleAgeGate(nonHeadlessRetailerData);
        }
    }, [currentRetailer, nonHeadlessRetailerData, handleAgeGate]);

    const handleNoClick = useCallback(() => {
        setIsOldEnough(false);
        storage.setItem("HEADLESS_AGE_GATE_PASSED", "false");
    }, []);

    const handleBirthDateChange = useCallback((e) => {
        setBirthDate(prevDate => ({ ...prevDate, [e.target.name]: e.target.value }));
    }, []);

    const handleBirthDateSubmit = useCallback((e) => {
        e.preventDefault();

        if (!birthDate.month || !birthDate.day || !birthDate.year) {
            setFormError('Please enter a valid birth date.');
            return;
        }

        setFormError('');

        const today = new Date();
        const birthDateObj = new Date(birthDate.year, birthDate.month - 1, birthDate.day);
        const ageDate = new Date(today - birthDateObj);
        const age = Math.abs(ageDate.getUTCFullYear() - 1970);
        const isOver21 = age >= 21;

        if (isOver21 && currentRetailer) {
            handleAgeGate(currentRetailer);
        } else {
            setIsOldEnough(false);
            storage.setItem("HEADLESS_AGE_GATE_PASSED", "false");
        }
    }, [birthDate, currentRetailer, handleAgeGate]);

    const handleInputKeyUp = useCallback((e, nextField) => {
        if (e.target.value.length === 2) {
            const nextInput = e.target.parentNode.parentNode.querySelector(`[name="${nextField}"]`);
            if (nextInput) {
                nextInput.focus();
            }
        }
    }, []);

    useEffect(() => {
        if (!ageGateContentSet.current) {
            const retailerAgeGateContent = retailers[retailerId]?.ageGateContent;
            const newAgeGateContent = retailerAgeGateContent || storedRetailer?.ageGateContent || locationGateConfig.ageGateContentArea;
            setAgeGateContent(newAgeGateContent);
            ageGateContentSet.current = true;
        }
        setIsLoading(false);
    }, [retailers, retailerId, storedRetailer, locationGateConfig]);

    useEffect(() => {
        if (retailerId && !storedRetailer) {
            const foundRetailer = retailers[retailerId];
            if (foundRetailer) {
                setCurrentRetailer(foundRetailer);
            }
        } else if (storedRetailer) {
            setCurrentRetailer(storedRetailer);
        }
    }, [retailerId, storedRetailer, retailers]);

    if (isLoading) {
        return <div>Loading...</div>;
    }

    const ageGateDeniedMessage = locationGateConfig.ageGateDeniedMessage || "Sorry, you are not old enough to view this content.";

    return (
        <div className="headless-age-gate">
            {isOldEnough ? (
                ageGateContent ? (
                    <div dangerouslySetInnerHTML={renderHtml(ageGateContent)} />
                ) : (
                    "Are you 21+?"
                )
            ) : (
                <div
                    className="headless-age-gate-denied"
                    dangerouslySetInnerHTML={renderHtml(ageGateDeniedMessage)}
                />
            )}
            {isOldEnough && (ageGateType === "birthday" ? (
                <form className="headless-age-gate-age" onSubmit={handleBirthDateSubmit}>
                    <div className="headless-age-gate-inputs">
                        {['month', 'day', 'year'].map((field, index) => (
                            <div key={field} className="headless-age-gate-input-wrap">
                                <label htmlFor={field}>{field.charAt(0).toUpperCase() + field.slice(1)}</label>
                                <input
                                    type="number"
                                    name={field}
                                    value={birthDate[field]}
                                    onChange={handleBirthDateChange}
                                    onKeyUp={(e) => handleInputKeyUp(e, ['day', 'year', ''][index])}
                                    placeholder={field === 'year' ? 'YYYY' : field.toUpperCase().slice(0, 2)}
                                />
                            </div>
                        ))}
                    </div>
                    <button className='headless-button headless-age-gate-age-submit' type='submit'>
                        Go
                    </button>
                    {formError && <div className="form-error">{formError}</div>}
                </form>
            ) : (
                <div className="headless-age-gate-buttons">
                    <button className="headless-button headless-agegate-yes" onClick={handleYesClick}>
                        Yes
                    </button>
                    <button className="headless-button headless-agegate-no" onClick={handleNoClick}>
                        No
                    </button>
                </div>
            ))}
        </div>
    );
};

export default AgeGate;
